import { createSlice } from "@reduxjs/toolkit";
var feedSideBar = createSlice({
  name: "feedSidebar",
  initialState: {
    count: 0,
    genderOptions: [],
    loading: false,
    open: false,
    selectedGender: null
  },
  reducers: {
    openSidebar: function openSidebar(state) {
      state.open = true;
    },
    closeSidebar: function closeSidebar(state) {
      state.open = false;
    },
    setFilterCount: function setFilterCount(state, action) {
      state.count = action.payload;
    },
    setLoading: function setLoading(state, action) {
      state.loading = action.payload;
    },
    setGenderOptions: function setGenderOptions(state, action) {
      state.genderOptions = action.payload;
    },
    setSelectedGender: function setSelectedGender(state, action) {
      state.selectedGender = action.payload;
    }
  }
});
var _feedSideBar$actions = feedSideBar.actions,
    closeSidebar = _feedSideBar$actions.closeSidebar,
    openSidebar = _feedSideBar$actions.openSidebar,
    setFilterCount = _feedSideBar$actions.setFilterCount,
    setGenderOptions = _feedSideBar$actions.setGenderOptions,
    setLoading = _feedSideBar$actions.setLoading,
    setSelectedGender = _feedSideBar$actions.setSelectedGender;
export { closeSidebar, openSidebar, setFilterCount, setGenderOptions, setLoading, setSelectedGender };
export default feedSideBar.reducer;